import AiClinicSettings from './AiClinicSettings';

export default AiClinicSettings;
